import { useMutation } from '@tanstack/react-query';
import * as Service from '../services/DismissWinnerPopup';
import type { IDismissWinnerPopupParameters } from '../types/BestInDental.parameters';

/**
 * React Query mutation hook for dismissing the Best-in-Dental winner popup
 *
 * @returns Mutation hook with mutate function and state (isPending, isError, isSuccess)
 *
 * @example
 * const dismissPopup = useDismissWinnerPopup();
 * dismissPopup.mutate({ year: 2026 });
 */
export const useDismissWinnerPopup = () => {
  return useMutation({
    // Accept params from component but don't pass to service (API doesn't need it)
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    mutationFn: (_params: IDismissWinnerPopupParameters) => Service.dismissWinnerPopup(),
    meta: {
      skipGlobalErrorToaster: true, // Component handles errors
    },
  });
};
